import React, { useEffect, useState, useRef } from 'react';
import CloseBar from "../../../assets/images/ttd/close-sidebar.png"
import { useForm } from "react-hook-form";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

function NegativeRate({ negativeRate, setNegativeRate, handleNegRating, scrollableDivRef, buttonRef,dropdownPosition,
    dropdownRef }) {
    const [showinput, setShowInput] = useState(false)
    const { register, formState: { errors }, handleSubmit, setValue, clearErrors,reset } = useForm();
    const reasonList = ["Harmful or Offensive","Not Relevant", "Too Repetitive", "Not Accurate", "Other"]

    const handleRadioChange = (data) => {
        clearErrors("reason")
        if (data === "Other") {
            setValue("reason", "")
            setShowInput(true)
        } else {
            setShowInput(false)
            setValue("reason", data)
            handleNegRating(data)
            setNegativeRate(false)
        }
    }
    const formSubmit = (data) => {
        handleNegRating(data?.reason)
        setNegativeRate(false)
    }

    useEffect(()=>{
        reset()
    },[negativeRate])
    return (
        <>
            <div className={`negative-rate-wrapper ${negativeRate ? "show-leave-form" : ""}`} ref={dropdownRef}>
                <form onSubmit={handleSubmit(formSubmit)}>
                    <div className="drawer-body">
                            <ul className='negative-list'>
                                {reasonList.map((data, j) => (
                                    <li onClick={() => handleRadioChange(data)}>{data}</li>
                                ))}
                            </ul>
                            {/* <div className="radio-list-wrap" >
                                <input type="text" className='input-hidden' {...register("reason", { required: { value: "true", message: "Please select atleast one reason." } })} />
                                <label className="item-radio radio-block">
                                    <input className="form-check-input" type="radio" name="reasonVal" value={data}  />
                                    <div className="radio-content"></div>
                                    <div className='text'></div>
                                </label>
                            </div> */}

                        {
                            showinput && <>
                                <textarea className='form-control' {...register("reason", { required: { value: "true", message: "Please enter reason." } })} ></textarea>
                                {errors?.reason && <div className='error'>{errors?.reason?.message}</div>}
                                <div className="form-action-group">
                                    <button className="btn btn-default btn-rounded-full">Submit</button>
                                </div>
                            </>
                        }
                    </div>
                </form>
            </div>
        </>
    )
}
export default NegativeRate;
